class LinkedList {
  constructor() {
    this._first = null;
    this._length = 0;
  }
  get length() {
    return this._length;
  }
  add(item) {
    let node = new ListNode(item);
    node._list = this;
    if (this._first) {
      this._first._prev = node;
      node._next = this._first;
    }
    this._first = node;
    this._length++;
  }
  iterate(f) {
    let node = this._first;
    while (node) {
      if (f(node._value) === false) {
        let next = node._next;
        node.remove();
        node = next;
      } else node = node._next;
    }
  }
}

class ListNode {
  constructor(value) {
    this._value = value;
    this._prev = null;
    this._next = null;
    this._list = null;
  }
  get value() {
    return this._value;
  }
  get prev() {
    return this._prev;
  }
  get next() {
    return this._next;
  }
  get list() {
    return this._list;
  }
  linkPrev(node) {
    if (this._prev) {
      this._prev._next = node;
      node._prev = this._prev;
    } else this._list._first = node;
    this._prev = node;
    node._next = this;
    node._list = this._list;
    this._list._length++;
  }
  linkNext(node) {
    if (this._next) {
      this._next._prev = node;
      node._next = this._next;
    }
    this._next = node;
    node._prev = this;
    node._list = this._list;
    this._list._length++;
  }
  remove() {
    if (this._prev) {
      this._prev._next = this._next;
    } else this._list._first = this._next;
    if (this._next) {
      this._next._prev = this._prev;
      this._next = null;
    }
    this._prev = null;
    this._list._length--;
    this._list = null;
  }
}

export {
  LinkedList,
  ListNode
};
